import React from 'react';
import styled from 'styled-components';
import MyPageLayout from '../../components/mypage/MyPageLayout';

interface MyPageBookmarkProps {}

const MyPageBookmark: React.FC<MyPageBookmarkProps> = () => {
  return (
    <MyPageLayout hideFooter={true}>
      <Container>
        <MainContainer>
          {/* 페이지 헤더 */}
          <PageHeader>
            <PageTitle>마이페이지</PageTitle>
          </PageHeader>

          {/* 브레드크럼 */}
          <NavigationBar>
            <BreadcrumbContainer>
              <BreadcrumbItem>마이페이지</BreadcrumbItem>
              <ChevronIcon>
                <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                  <path 
                    d="M1.73 3.07L6.26 7.6L1.73 12.13" 
                    stroke="rgba(55, 56, 60, 0.61)" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </ChevronIcon>
              <BreadcrumbItem>즐겨찾기</BreadcrumbItem>
            </BreadcrumbContainer>
          </NavigationBar>

          {/* 즐겨찾기 콘텐츠 */}
          <ContentSection>
            <SectionTitle>즐겨찾기</SectionTitle>
            <ContentText>즐겨찾기 페이지 내용이 여기에 들어갑니다.</ContentText>
          </ContentSection>
        </MainContainer>
      </Container>
    </MyPageLayout>
  );
};

// 스타일 컴포넌트들 (동일)
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const MainContainer = styled.div`
  width: 100%;
  max-width: 894px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 48px;
`;

const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  margin-top: 60px;
`;

const PageTitle = styled.h1`
  color: #171719;
  font-size: 40px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 700;
  line-height: 52px;
  margin: 0;
`;

const NavigationBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const BreadcrumbContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const BreadcrumbItem = styled.span`
  color: rgba(55, 56, 60, 0.61);
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.09px;
`;

const ChevronIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionTitle = styled.h2`
  color: black;
  font-size: 22px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  line-height: 30.01px;
  margin: 0;
`;

const ContentText = styled.p`
  color: rgba(55, 56, 60, 0.61);
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export default MyPageBookmark;
